import { render, staticRenderFns } from "./ViewTable.vue?vue&type=template&id=68940c2e&"
import script from "./ViewTable.vue?vue&type=script&lang=js&"
export * from "./ViewTable.vue?vue&type=script&lang=js&"
import style0 from "./ViewTable.vue?vue&type=style&index=0&id=68940c2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports